module.exports = __webpack_public_path__ + "img/live_logo.cdf69e9d.png";